/**
 * Created by olga on 16.02.2026
 */

const SeasonCollectionsStartTutorial = function () {
    return new TutorialScenario(SeasonCollectionsStartTutorial.NAME, {
        listSteps: SeasonCollectionsStartTutorial.listSteps,

        isAvailable: function () {
            return false;
        }
    });
};

SeasonCollectionsStartTutorial.listSteps = function () {
    return [
        SeasonCollectionsStartTutorial.createDialogueStep(),
        SeasonCollectionsStartTutorial.createSeasonWindowStep(),
        SeasonCollectionsStartTutorial.createRewardWindowStep()
    ];
};

SeasonCollectionsStartTutorial.createDialogueStep = function () {
    return new TutorialStep({
        onStart: function () {
            const bundleName = `stickers_book_season_dialogue_${cleverapps.stickersBook.season}`;
            const seasonBundle = bundles[bundleName];
            if (!seasonBundle || !seasonBundle.jsons.dialogues_json) {
                this.finish();
                return;
            }

            cleverapps.bundleLoader.loadBundle(bundleName, {
                onSuccess: () => {
                    const dialogueData = seasonBundle.jsons.dialogues_json.getJson();
                    if (!dialogueData) {
                        this.finish();
                        return;
                    }
                    const dialogue = new Dialogue(dialogueData, {
                        autoClose: true,
                        autoScroll: false,
                        showUp: true
                    });

                    dialogue.on("afterClose", () => {
                        this.finish();
                    });

                    new DialogueView(dialogue);
                }
            });
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonCollectionsStartTutorial.createSeasonWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            new StickersBookSeasonWindow({ isCompleted: false });
            cleverapps.focusManager.onceNoWindowsListener = this.finish.bind(this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonCollectionsStartTutorial.createRewardWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            cleverapps.stickersBook.givePrize(4, Sticker.SOURCES.tutorial);
            new StickersRewardWindow(true);
            cleverapps.focusManager.onceNoWindowsListener = this.finish.bind(this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonCollectionsStartTutorial.NAME = "season_collections_start_tutorial";